<template>
  <el-card style="margin-bottom:20px;">
    <div slot="header" class="clearfix">
      <span>个人中心</span>
    </div>

    <div class="user-profile">
      <div class="box-center">
        <pan-thumb
          :image="
            party.headImg
              ? party.headImg
              : 'https://ntocc-test.obs.cn-north-4.myhuaweicloud.com:443/2020-03-24/fec2b5028566493cbb738a388106b8be.png'
          "
          :height="'100px'"
          :width="'100px'"
          :hoverable="false"
        />
      </div>
      <div class="box-center">
        <div class="user-name text-center">{{ user.name }}</div>
      </div>
    </div>

    <div class="user-bio">
      <div class="user-education user-bio-section">
        <div class="user-bio-section-header">
          <svg-icon icon-class="education" /><span>用户信息</span>
        </div>
        <div class="user-bio-section-body">
          <div class="text-muted">
            <p>名称：{{ party.name }}</p>
            <p>电话：{{ party.phone }}</p>
            <p v-if="currentCompany && currentCompany.accountName">
              所属承运主体：{{ currentCompany.branchName }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import PanThumb from "@/components/PanThumb";
import { currentPartnerCompany } from "@/api/invoice";

export default {
  components: { PanThumb },
  props: {
    user: {
      type: Object,
      default: () => {
        return {
          name: "",
          email: "",
          roles: ""
        };
      }
    }
  },
  data() {
    return {
      party: this.$store.getters.party,
      currentCompany: null
    };
  },
  computed: {
    partyCode() {
      return this.$store.state.user.code;
    }
  },
  created() {
    // this.getCurrentPartnerCompany();
  },
  methods: {
    async getCurrentPartnerCompany() {
      try {
        let data = {
          partyCode: this.partyCode
        };
        let res = await currentPartnerCompany(data);
        if (res.status === 0) {
          //当前合作公司
          if (res.data && Object.keys(res.data.partnerCompany).length) {
            this.currentCompany = res.data.partnerCompany || null;
          }
          console.log("this.currentCompany======", this.currentCompany);
        }
        console.log("res=======", res);
      } catch (err) {}
    }
  }
};
</script>

<style lang="scss" scoped>
.box-center {
  margin: 0 auto;
  display: table;
}

.text-muted {
  color: #777;
}

.user-profile {
  .user-name {
    font-weight: bold;
  }

  .box-center {
    padding-top: 10px;
  }

  .user-role {
    padding-top: 10px;
    font-weight: 400;
    font-size: 14px;
  }

  .box-social {
    padding-top: 30px;

    .el-table {
      border-top: 1px solid #dfe6ec;
    }
  }

  .user-follow {
    padding-top: 20px;
  }
}

.user-bio {
  margin-top: 20px;
  color: #606266;

  span {
    padding-left: 4px;
  }

  .user-bio-section {
    font-size: 14px;
    padding: 15px 0;

    .user-bio-section-header {
      border-bottom: 1px solid #dfe6ec;
      padding-bottom: 10px;
      margin-bottom: 10px;
      font-weight: bold;
    }
  }
}
</style>
